// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleOnboarding__container-cf943b {
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/SubmitButton/ScheduleOnboarding/styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".container {\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduleOnboarding__container-cf943b`
};
module.exports = ___CSS_LOADER_EXPORT___;
